import {DxConfigService} from "../../dx-core/services/dx-config.service";
import {EventEmitter, Injectable, Injector} from "@angular/core";
import {DxPageHeaderOptions} from "../../dx-page-markup/domain/ui-options/page-header/dx-page-header-options";
import {DxHttpDispatcher} from "../../dx-core/services/dx-http-dispatcher.service";
import {DxObjectMapper} from "../../dx-core/services/dx-object-mapper.service";
import {fromPromise} from "rxjs/internal/observable/fromPromise";
import {forkJoin, Observable} from "rxjs";
import {DxNavigatorOptions} from "../../dx-navigation/domain/ui-options/dx-navigator/dx-navigator-options";
import {DxTreeListOptions} from "../../dx-lists/domain/ui-options/tree-list/dx-tree-list-options";
import {DxModalsConfig} from "../../dx-modals/config/dx-modals-config";
import {DxModalOptions} from "../../dx-modals/domain/ui-options/dx-modal-options";
import {DxGridOptions} from "../../dx-grid/domain/ui-options/dx-grid-options";
import {map, tap} from "rxjs/operators";
import {DxAppEvent} from "../../dx-core/domain/events/dx-app-event";
import {BdpkDeveloperEnvCategory} from "../domain/bdpk-developer-env-category";


@Injectable()
export class BdpkConfigService extends DxConfigService {

  events = new EventEmitter<DxAppEvent>();

  private _http: DxHttpDispatcher;
  private _mapper: DxObjectMapper;
  private _bdpkTaskSettingsGridOptions: DxGridOptions;
  private _bdpkTaskSettingsTreeOptions: DxTreeListOptions;

  private _bdpkPageHeaderOptions: DxPageHeaderOptions;
  private _bdpkLoginPageHeaderOptions: DxPageHeaderOptions;
  private _bdpkErrorPageHeaderOptions: DxPageHeaderOptions;
  private _bdpkNavigatorOptions: DxNavigatorOptions;
  // private _pitAgreementTasksListOptions: DxTaskListOptions;
  // private _pitActivitiesRegistryDocListOptions: DxTreeListOptions;
  private _bdpkModalsConfig: DxModalsConfig;
  // private _pitActivitiesGridOptions: DxGridOptions;
  // private _pitActivitiesCardGridOptions: Map<string, DxGridOptions>;
  // private _pitPurchaseCardGridOptions: Map<string, DxGridOptions>;
  // private _pitPurchasesRegistryGridOptions: DxGridOptions;
  // private _pitPurchasesRegistryTreeOptions: DxTreeListOptions;
  // private _pitPlanningCardGridsOptions: Map<string, DxGridOptions>;
  // private _pitReportsTreeOptions: DxTreeListOptions;
  // private _pitNciRegistryTreeOptions: DxTreeListOptions;
  // private _pitNciRegistryGridOptions: DxGridOptions;
  // private _pitContractsRegistryTreeOptions: DxTreeListOptions;
  // private _pitContractsRegistryGridOptions: DxGridOptions;
  // private _pitPlanningListOptions: DxListOptions;
  // private _startYear: number;
  // private _budgetPeriod: number;
  // private _budgetPeriodName: string;

  constructor(protected _injector: Injector) {
    super(_injector);
    this._http = this._injector.get(DxHttpDispatcher);
    this._mapper = this._injector.get(DxObjectMapper);
    // this._startYear = new Date().getFullYear();
  }

  /**
   *   `loadAppConfig` - метод для асинхронной загрузки конфигов приложения.
   *   @return `Promise<boolean>` - для блокировки загрузки приложения должен именно промис.
   **/
  public loadAppConfig(): Promise<boolean> {
    const asyncTasks: Observable<boolean>[] = [];
    asyncTasks.push(this.loadBdpkPageHeaderOptions());
    asyncTasks.push(this.loadBdpkLoginPageHeaderOptions());
    asyncTasks.push(this.loadBdpkErrorPageHeaderOptions());
    asyncTasks.push(this.loadBdpkNavigatorOptions());
    asyncTasks.push(this.loadBdpkModalsOptions());
    asyncTasks.push(this.loadBdpkTaskSettingsGridOptions());
    asyncTasks.push(this.loadBdpkTaskSettingsTreeOptions());

    return new Promise<boolean>((resolve) => {
      forkJoin(asyncTasks).subscribe(data => {
        if (data && asyncTasks.length === data.length) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  }

  public loadBdpkPageHeaderOptions(): Observable<boolean> {
    const promise = new Promise<boolean>((resolve) => {
      this._http
        .getMockedData('assets/mocks/pit-ui/pit-common/pit-page-header-options.json')
        .subscribe(response => {
          this._bdpkPageHeaderOptions = this._mapper.deserialize<DxPageHeaderOptions>(response.body, DxPageHeaderOptions);
          resolve(true);
        }, errorResponse => {
          throw DxHttpDispatcher.handleHttpError(errorResponse);
        });
    });
    return fromPromise<boolean>(promise);
  }


  public loadBdpkErrorPageHeaderOptions(): Observable<boolean> {
    const promise = new Promise<boolean>((resolve) => {
      this._http
        .getMockedData('assets/mocks/pit-ui/pit-common/pit-error-page-header-options.json')
        .subscribe(response => {
          this._bdpkErrorPageHeaderOptions = this._mapper.deserialize<DxPageHeaderOptions>(response.body, DxPageHeaderOptions);
          resolve(true);
        }, errorResponse => {
          throw DxHttpDispatcher.handleHttpError(errorResponse);
        });
    });
    return fromPromise<boolean>(promise);
  }

  public loadBdpkLoginPageHeaderOptions(): Observable<boolean> {
    const promise = new Promise<boolean>((resolve) => {
      this._http
        .getMockedData('assets/mocks/pit-ui/pit-common/pit-login-page-header-options.json')
        .subscribe(response => {
          this._bdpkLoginPageHeaderOptions = this._mapper.deserialize<DxPageHeaderOptions>(response.body, DxPageHeaderOptions);
          resolve(true);
        }, errorResponse => {
          throw DxHttpDispatcher.handleHttpError(errorResponse);
        });
    });
    return fromPromise<boolean>(promise);
  }

  public loadBdpkNavigatorOptions(): Observable<boolean> {
    const promise = new Promise<boolean>((resolve) => {
      this._http
        .getMockedData('assets/mocks/pit-ui/pit-navigation/pit-navigator-options.json')
        .subscribe(response => {
          this._bdpkNavigatorOptions = this._mapper.deserialize<DxNavigatorOptions>(response.body, DxNavigatorOptions);
          resolve(true);
        }, errorResponse => {
          throw DxHttpDispatcher.handleHttpError(errorResponse);
        });
    });
    return fromPromise<boolean>(promise);
  }

  public loadBdpkTaskSettingsGridOptions(): Observable<boolean> {
    const promise = new Promise<boolean>((resolve) => {
      this._http
        .getMockedData('assets/mocks/bdpk/ui/tasks/bdpk-task-settings-grid-options.json')
        .subscribe(response => {
          this._bdpkTaskSettingsGridOptions = this._mapper.deserialize<DxGridOptions>(response.body, DxGridOptions);
          resolve(true);
        }, errorResponse => {
          throw DxHttpDispatcher.handleHttpError(errorResponse);
        });
    });
    return fromPromise<boolean>(promise);
  }

  public loadBdpkTaskSettingsTreeOptions(): Observable<boolean> {
    const promise = new Promise<boolean>((resolve) => {
      this._http
        .getMockedData('assets/mocks/bdpk/ui/tasks/bdpk-task-settings-tree-options.json')
        .subscribe(response => {
          this._bdpkTaskSettingsTreeOptions = this._mapper.deserialize<DxTreeListOptions>(response.body, DxTreeListOptions);
          resolve(true);
        }, errorResponse => {
          throw DxHttpDispatcher.handleHttpError(errorResponse);
        });
    });
    return fromPromise<boolean>(promise);
  }

  public loadBdpkModalsOptions(): Observable<boolean> {
    const promise = new Promise<boolean>((resolve) => {
      this._http
        .getMockedData('assets/mocks/pit-ui/pit-common/pit-modals-options.json')
        .subscribe(response => {
          const map = this._mapper.deserializeASMap<String, DxModalOptions>(response.body, String, DxModalOptions);
          this._bdpkModalsConfig = new DxModalsConfig({});
          if(map.has('INFO')) this._bdpkModalsConfig.infoModalConfig = map.get('INFO');
          if(map.has('WARN')) this._bdpkModalsConfig.warnModalConfig = map.get('WARN');
          if(map.has('ERROR')) this._bdpkModalsConfig.errorModalConfig = map.get('ERROR');
          if(map.has('CONFIRM')) this._bdpkModalsConfig.confirmModalConfig = map.get('CONFIRM');
          if(map.has('EDIT')) this._bdpkModalsConfig.editModalConfig = map.get('EDIT');
          console.log('Finishing load modals options');
          resolve(true);
        }, errorResponse => {
          throw DxHttpDispatcher.handleHttpError(errorResponse);
        });
    });
    return fromPromise<boolean>(promise);
  }

  loadScheduleGridOptions(): Observable<DxGridOptions> {
    return this._http.getMockedData('assets/mocks/bdpk/ui/schedules/bdpk-schedule-grid-options.json')
                     .pipe(
                        map(response => this._mapper.deserialize(response.body, DxGridOptions))
                     );
  }

  loadSchedulerLogsOptions(): Observable<DxGridOptions> {
    return this._http.getMockedData('assets/mocks/bdpk/ui/scheduler-logs/bdpk-scheduler-logs-options.json')
                     .pipe(
                        map(response => this._mapper.deserialize(response.body, DxGridOptions))
                     );
  }

  public bdpkFilesGridOptions: DxGridOptions;


  public get bdpkPageHeaderOptions(): DxPageHeaderOptions {
    return this._bdpkPageHeaderOptions;
  }

  public get bdpkErrorPageHeaderOptions(): DxPageHeaderOptions {
    return this._bdpkErrorPageHeaderOptions;
  }

  public get bdpkLoginPageHeaderOptions(): DxPageHeaderOptions {
    return this._bdpkLoginPageHeaderOptions;
  }

  public get bdpkNavigatorOptions(): DxNavigatorOptions {
    return this._bdpkNavigatorOptions;
  }

/*
  public get pitAgreementTasksListOptions(): DxTaskListOptions {
    return this._pitAgreementTasksListOptions;
  }

  public get pitActivitiesRegistryDocListOptions(): DxTreeListOptions {
    return this._pitActivitiesRegistryDocListOptions;
  }

  public get pitActivitiesGridOptions(): DxGridOptions {
    return this._pitActivitiesGridOptions;
  }

  public get pitActivitiesCardGridOptions(): Map<string, DxGridOptions> {
    return this._pitActivitiesCardGridOptions;
  }

  get pitPurchaseCardGridOptions(): Map<string, DxGridOptions> {
    return this._pitPurchaseCardGridOptions;
  }

  get pitPurchasesRegistryGridOptions(): DxGridOptions {
    return this._pitPurchasesRegistryGridOptions;
  }

  get pitPurchasesRegistryTreeOptions(): DxTreeListOptions {
    return this._pitPurchasesRegistryTreeOptions;
  }

  get pitPlanningCardGridsOptions(): Map<string, DxGridOptions> {
    return this._pitPlanningCardGridsOptions;
  }

  get pitNciRegistryGridOptions(): DxGridOptions {
    return this._pitNciRegistryGridOptions;
  }
*/

  public get bdpkModalsConfig(): DxModalsConfig {
    return this._bdpkModalsConfig;
  }

/*
  get pitContractsRegistryTreeOptions(): DxTreeListOptions {
    return this._pitContractsRegistryTreeOptions;
  }

  get pitContractsRegistryGridOptions(): DxGridOptions {
    return this._pitContractsRegistryGridOptions;
  }
*/

  public get bdpkBackendAnalyticalTasksEndPoint(): string {
    return this._env.backend.analyticalTasks;
  }

  public get bdpkBackendSchedulerEndPoint(): string {
    return this._env.backend.schedulerService;
  }

  public get bdpkHueURLPattern(): string {
    return this._env.reporting.hueURLPattern;
  }

  public get bdpkSparkURLPattern(): string {
    return this._env.reporting.sparkURLPattern;
  }

  public get bdpkSaikuReportsURLPattern(): string {
    return this._env.reporting.saikuReportsURLPattern;
  }

  public get bdpkFileURLPattern(): string {
    return this._env.reporting.fileURLPattern;
  }

  public get bdpkRstudioURLPattern(): string {
    return this._env.reporting.rstudioURLPattern;
  }

  public get bdpkJupyterURLPattern(): string {
    return this._env.reporting.jupyterURLPattern;
  }

  public get bdpkRedirectService(): string {
    return this._env.reporting.redirectService;
  }







  public get pitBackendNciEndpoint(): string {
    return this._env.backend.nsi;
  }

  public get pitBackendActivitiesEndPoint(): string {
    return this._env.backend.activities;
  }

  public get pitBackendBPMEndPoint(): string {
    return this._env.backend.bpm;
  }

  public get pitBackendPlanningEndPoint(): string {
    return this._env.backend.planning;
  }

  public get pitBackendUsersEndPoint(): string {
    return this._env.backend.users;
  }

  public get pitBackendResponsiblesEndPoint(): string {
    return this._env.backend.responsibles;
  }

  public get pitBackendContractsEndPoint(): string {
    return this._env.backend.contracts;
  }

  public get pitReportingSaikuReportsURLPattern(): string {
    return this._env.reporting.saikuReportsURLPattern;
  }

  public get pitProduction(): boolean {
    return this._env.production;
  }

  public get pitBackendPurchasesEndPoint(): string {
    return this._env.backend.purchases;
  }

  public get bdpkFileStorageService(): string {
    return this._env.backend.fileStorage;
  }

  public get pitSessionStorageService(): string {
    return this._env.backend.sessionStorage;
  }

/*
  get pitReportsTreeOptions(): DxTreeListOptions {
    return this._pitReportsTreeOptions;
  }

  get pitNciRegistryTreeOptions(): DxTreeListOptions {
    return this._pitNciRegistryTreeOptions;
  }

  get pitPlanningListOptions(): DxListOptions {
    return this._pitPlanningListOptions;
  }

  get startYear(): number {
    return this._startYear;
  }

  set startYear(value: number) {
    this._startYear = value;
  }

  get budgetPeriod(): number {
    return this._budgetPeriod;
  }

  set budgetPeriod(value: number) {
    this._budgetPeriod = value;
    this.events.emit(new DxAppEvent('bdpk-config-service', value));
  }

  get budgetPeriodName(): string {
    return this._budgetPeriodName;
  }

  set budgetPeriodName(value: string) {
    this._budgetPeriodName = value;
  }

*/
  get bdpkTaskSettingsGridOptions(): DxGridOptions {
    return this._bdpkTaskSettingsGridOptions;
  }

  get bdpkTaskSettingsTreeOptions(): DxTreeListOptions {
    return this._bdpkTaskSettingsTreeOptions;
  }

  getDevelopmentEnvironments(): Observable<BdpkDeveloperEnvCategory[]> {
    return this._http.get(this.bdpkBackendAnalyticalTasksEndPoint + '/development-environments', {observe: "response"}).pipe(
      map(response => this._mapper.deserializeASArray<BdpkDeveloperEnvCategory>(response.body, BdpkDeveloperEnvCategory)));
  }
}
